import { render } from "./UpdateStore.vue?vue&type=template&id=a810d5e4"
import script from "./UpdateStore.vue?vue&type=script&lang=js"
export * from "./UpdateStore.vue?vue&type=script&lang=js"

import "./UpdateStore.vue?vue&type=style&index=0&id=a810d5e4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__